import { combineReducers } from "redux";
import Login from "./login";
import updateRow from "./updateRow";
import loading from "./Loading";
import Company from "./getCompany"
export default combineReducers({
  Login,
  updateRow,
  loading,
  Company
});
